import { render, staticRenderFns } from "./organize-section.vue?vue&type=template&id=701561f2&scoped=true&"
import script from "./organize-section.vue?vue&type=script&lang=js&"
export * from "./organize-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701561f2",
  null
  
)

export default component.exports